var map = {
	"./cbw.png": 1666,
	"./evmos_testnet.png": 9448,
	"./merkle_tree.png": 55773,
	"./mm.png": 96893,
	"./polygon_mumbai.png": 23353,
	"./wc.png": 5021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57872;